// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper__SpQTL","close":"style_close__SUjrE","subsection":"style_subsection__1wCpP","h1":"style_h1__68yWL"};